import { Contact } from './Contact';
export class AccessGroupModel {
    id;
    name;
    meta;
    members;
}
// Development of AccessGrouped has been postponed. They are currently not in use, and all references in the code will
// be removed after some time if it becomes clear that we will not be developing them in the near future.
export class AccessGroup extends AccessGroupModel {
    type;
    constructor(model) {
        super();
        Object.keys(model).forEach((key) => {
            switch (key) {
                case 'members':
                    this.members = model.members.map((member) => new Contact(member));
                    break;
                default:
                    this[key] = model[key];
            }
        });
    }
    get shortName() {
        return this.name;
    }
    get description() {
        return '';
    }
    getAssigneeId() {
        return `${this.id}-${this.type}`;
    }
}
